import Axios from 'axios';
import { getAccessToken } from './helper';


export const ENVIRONMENTS = {
  DEV: "DEV",
  PROD: "PROD",
  LOCAL: "LOCAL",
} as const;

type Environment = (typeof ENVIRONMENTS)[keyof typeof ENVIRONMENTS];

// Read environment from .env file
export const ENVIRONMENT: Environment = (process.env.ENVIRONMENT || "DEV") as Environment;

// Get API URL based on environment
const getApiUrl = (): string => {
  switch (ENVIRONMENT) {
    case ENVIRONMENTS.DEV:
      return process.env.APIURL_DEV;
    case ENVIRONMENTS.PROD:
      return process.env.APIURL_PROD ;
    case ENVIRONMENTS.LOCAL:
      return process.env.APIURL_LOCAL;
    default:
      return process.env.APIURL_DEV ;
  }
};

export const API_BASE_URL = getApiUrl();
export const DEFAULT_TOKEN = process.env.DEFAULT_TOKEN || '';
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || '';

export const axiosBase = Axios.create({ baseURL: API_BASE_URL });

axiosBase.interceptors.request.use(
    async config => {
        const accessToken = getAccessToken();
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;

    },
    error => {
        return Promise.reject(error);
    }
);

export const errorHandler = (error: any) => {
    if (error.response) {
        return error.response.data
    } else if (error.message) {
        return { errorMessage: error.message }
    } else {
        return { errorMessage: "Something went wrong" }
    }
}

